// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo, useState } from "react";

import { Button, Loading } from "../../atoms";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import { downloadExcel } from "../../../util/downloadExcel";
import {
    useGetMerchantsWithParentMerchant,
    useGetMerchantCommissionsByBank
} from "../../../hooks";

import {
    FormControl,
    useTheme,
    useMediaQuery,
    Autocomplete,
    TextField,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import {
    Table,
} from "../../molecules";

export const MerchantCommissionsByBankFilter = () => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const [queryOptions, setQueryOptions] = React.useState({});
    const [isPageLoading, setIsPageLoading] = useState(true);

    const forms = useForm();

    const { data: rawMerchantList, isLoading: isMerchantLoading } = useGetMerchantsWithParentMerchant("ACTIVE");
    const { mutate: getMerchantCommissionsByBank, isLoading: isMerchantCommissionsLoading } = useGetMerchantCommissionsByBank();

    const merchantList = useMemo(() => {
        setIsPageLoading(false);
        return rawMerchantList?.data?.map((item: { merchantName: string, merchantId: number }) => {
            return {
                label: "( " + item.taxNumber + " ) " + item.merchantName + ` (${item.merchantId})`,
                value: item.merchantId
            }
        });
    }, [rawMerchantList?.data]);

    const isLoading = false;
    const [selectedMerchant, setSelectedMerchant] = useState<{ label: string, value: number } | null>(null);
    const [showTable, setShowTable] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [isFilterAccordionExpanded, setIsFilterAccordionExpanded] = useState(true);

    const onExport = () => {
        function fieldValue(data) {
            return data.map((item) => {
                return {
                    "Banka Adı": item?.bankName,
                    "Tek Ödeme Bloke": item?.merchantBlockDays,
                    "Kredi Kartı": item?.creditCard,
                    "Banka Kartı": item?.debitCard,
                    "Yabancı Kartı": item?.internationalCard,
                    "SoftPOS": item?.softPOSCommission,
                    "Taksitli Bloke": item?.merchantBlockDaysOnus,
                    "2. Taksit": item?.installment2,
                    "3. Taksit": item?.installment3,
                    "4. Taksit": item?.installment4,
                    "5. Taksit": item?.installment5,
                    "6. Taksit": item?.installment6,
                    "7. Taksit": item?.installment7,
                    "8. Taksit": item?.installment8,
                    "9. Taksit": item?.installment9,
                    "10. Taksit": item?.installment10,
                    "11. Taksit": item?.installment11,
                    "12. Taksit": item?.installment12
                };
            });
        }

        if (tableData) {
            const refactoredData = fieldValue(tableData);
            downloadExcel(refactoredData || [], "İşyeri komisyon oranları", null);
            return;
        }
    }

    const getAndFillTableWithMerchantCommissions = () => {

        if (selectedMerchant == null) {

        }

        setIsPageLoading(true);

        getMerchantCommissionsByBank(selectedMerchant?.value, {
            onSuccess: (result) => {
                setTableData(result?.data);
                setIsFilterAccordionExpanded(false);
                setShowTable(true);
                setIsPageLoading(false);
            },
            onError: (result) => {

            }
        })

    }

    const getQueryParams = (filters: any) => {
        const queryParams: any = {};

        for (let key in filters) {
            let value = filters[key];
            if (value === "false") {
                queryParams[key] = false;
            } else if (key === 'filterMerchantId') {
                if (value !== null && value !== undefined && value.toString().length > 0) {
                    queryParams['filterSubMerchantId'] = Number(value);
                }
            } else if (value !== null && value !== undefined && value.toString().length > 0) {
                if (decimalFields.includes(key) && !isNaN(parseFloat(value))) {
                    queryParams[key] = Number(parseFloat(value).toFixed(2));
                } else {
                    queryParams[key] = value;
                }
            }
        }
        return queryParams;
    };

    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(null, args);
            }, delay);
        };
    };

    const handleFilterChange = debounce((filters) => {
        if (filters.clearFilter) {
            localStorage.removeItem('merchantCommissionsByBank')
            return setQueryOptions({});
        }

        const queryParams = getQueryParams(filters);

        const isValueValid = (key, value) => {
            if (key === 'installmentCount' || key === 'cardType' || key === 'amount' || key === 'totalAmount' || key === 'totalComission') { // Özel alan kontrolü
                return value?.toString().length >= 1;
            } else {
                return value?.toString().length >= 3;
            }
        }


        const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));

        const previousKeysLength = Object.keys(previousQueryParams.current).length;
        const currentKeysLength = Object.keys(queryParams).length;

        if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
            return;
        }

        if (allValuesValid || (previousKeysLength > currentKeysLength)) {
            setQueryOptions(queryParams);
            localStorage.setItem('merchantCommissionsByBank', JSON.stringify(queryParams));
        }

        previousQueryParams.current = queryParams;

    }, 500);
    const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;


    const columns: GridColDef[] = useMemo(() => {
        return [
            { field: "bankName", headerName: "Banka Adı", width: 300 },
            { field: "merchantBlockDays", headerName: "Tek Ödeme Bloke", width: 120 },
            { field: "creditCard", headerName: "Kredi Kartı", width: 120 },
            { field: "debitCard", headerName: "Banka Kartı", width: 120 },
            { field: "internationalCard", headerName: "Yabancı Kartı", width: 120 },
            { field: "softPOSCommission", headerName: "SoftPOS", width: 120 },
            { field: "merchantBlockDaysOnus", headerName: "Taksitli Bloke", width: 120 },
            { field: "installment2", headerName: "2. Taksit", width: 120 },
            { field: "installment3", headerName: "3. Taksit", width: 120 },
            { field: "installment4", headerName: "4. Taksit", width: 120 },
            { field: "installment5", headerName: "5. Taksit", width: 120 },
            { field: "installment6", headerName: "6. Taksit", width: 120 },
            { field: "installment7", headerName: "7. Taksit", width: 120 },
            { field: "installment8", headerName: "8. Taksit", width: 120 },
            { field: "installment9", headerName: "9. Taksit", width: 120 },
            { field: "installment10", headerName: "10. Taksit", width: 120 },
            { field: "installment11", headerName: "11. Taksit", width: 120 },
            { field: "installment12", headerName: "12. Taksit", width: 120 }
        ];
    });

    return (
        <>
            {isPageLoading && <Loading />}
            <Stack flex={1} justifyContent={'space-between'}>
                <Stack flex={1} p={2}>
                    <BaseFilterTableWithAccordion summary="İşyeri Komisyon Oranları" isExpanded={isFilterAccordionExpanded} setExpanded={setIsFilterAccordionExpanded} setTableVisibility={setShowTable}
                        child={<Stack spacing={4}>
                            <Stack spacing={3} direction={isDesktop ? 'row' : 'column'} width={isDesktop ? '100%' : 'auto'} maxWidth={1308}>
                                <FormControl sx={{ flex: 1 }}>
                                    {merchantList && (
                                        <Controller
                                            control={forms.control}
                                            name="merchantId"
                                            render={({ field, fieldState }) => {
                                                return (
                                                    <Autocomplete
                                                        sx={{ mr: isDesktop ? 2 : 0 }}
                                                        onChange={(event, selectedValue) => {
                                                            setSelectedMerchant(selectedValue);
                                                            field.onChange(selectedValue?.value || 0);
                                                        }}
                                                        id="merchantId"
                                                        options={merchantList}
                                                        // defaultValue={user?.id ? selectedMerchant : null}
                                                        getOptionLabel={(option: {
                                                            label: string;
                                                            value: number;
                                                        }) => option.label}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Üye İşyeri"
                                                                error={fieldState.invalid}
                                                                fullWidth
                                                            />
                                                        )}
                                                    />
                                                );
                                            }}
                                        />
                                    )}
                                </FormControl>
                                <Button
                                    onClick={getAndFillTableWithMerchantCommissions}
                                    variant="contained"
                                    text={"ARA"}
                                />
                            </Stack>
                        </Stack>} />
                    <Stack flex={1} mt={2}  >
                        {showTable && (
                            <>
                                <Table
                                    getRowId={() => { return Math.random(100000) }}
                                    className="myTable"
                                    isMasterDetailActive={false}
                                    isRowExpandable={false}
                                    columnVisibilityConfigKey="merchantCommissionsByBankVisibilityKey"
                                    filterKey="merchantCommissionsByBank"
                                    hasActiveFilters={hasActiveFilters}
                                    handleFilterChange={handleFilterChange}
                                    paginationModel={{}}
                                    onPaginationModelChange={() => { }}
                                    paginationMode="server"
                                    rowCount={tableData?.length ?? 0}
                                    isRowSelectable={() => false}
                                    rows={tableData ?? []}
                                    customLabelDisplayedRows={true}
                                    autoHeight={false}
                                    columns={columns}
                                    exportFileName="İşyeri Komisyon Oranları"
                                    onSave={() => onExport()}
                                />
                            </>
                        )}
                    </Stack>
                </Stack>
            </Stack>
        </>
    );
}